import { CONFIG } from '@/components/driveToStore/FootfallReport/components/buyerInsights.constants';

import type { BuyerInsightsGender } from '@/types/footfall';

const AGE_SUFFIX: Record<string, string> = {
  '18-24': '18_24',
  '25-34': '25_34',
  '35-44': '35_44',
  '45-54': '45_54',
  '55-64': '55_64',
  '65+': '65'
};

function buildFigureUrl(fileName: string): string {
  return `${CONFIG.CDN_BASE}/buyerInsights/${fileName}`;
}

const FALLBACK_FIGURE = buildFigureUrl('Empty_state.png');

export function getBuyerInsightsFigure(gender: BuyerInsightsGender, age: string): string {
  const ageSuffix = AGE_SUFFIX[age];

  if (!ageSuffix) {
    return FALLBACK_FIGURE;
  }

  return buildFigureUrl(`${gender}_${ageSuffix}.png`);
}
